module.exports = __webpack_public_path__ + "media/ding.f3606af2.mp3";